const inviteSignupBySuperAdmin = {
  toastr: 'Invitation sent',
  toastr1: 'The invitation has been sent successfully'
};

export default inviteSignupBySuperAdmin;
